<div>
  <ion-grid fixed>
    <h6 class="ion-no-margin ion-no-padding padl10 padr10 title title-text-color">{{ title }}</h6>
    <ion-row class="pad6">
      <ion-col size="6" *ngFor="let item of buttonListArray">
        <ion-button
          [routerLink]="item.landing_url"
          class="ion-no-margin white-btn btn font12"
          expand="block"
          mode="ios"
          (click)="handleGridButtonAction(item.title)"
        >
          <div class="btn_container">
            <img class="buttonGridIcon" [src]="item.carousel_img" [alt]="item.title" />
            <span class="l-spacing0">
              {{ item.title }}
            </span>
          </div>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-button
    *ngIf="buttonList.length > 4"
    class="ion-no-margin ion-margin-horizontal ion-margin-bottom font12 white-btn show-more-btn btn"
    (click)="onShowMore()"
    expand="block"
  >
    <ng-template [ngIf]="showMore">
      <span class="text-color">See More</span>
      <ion-icon class="primary-icon-color" slot="end" name="chevron-down"></ion-icon>
    </ng-template>
    <ng-template [ngIf]="!showMore">
      <span class="text-color">See Less</span>
      <ion-icon class="primary-icon-color" slot="end" name="chevron-up"></ion-icon>
    </ng-template>
  </ion-button>
</div>